<template>
  <div>
    <div v-if="eyebrowText || eyebrowTextHtml" v-style:c="eyebrowTextColor" class="uppercase" :class="eyebrowTextStyle">
      <cms-plain-text :content="{ eyebrowText, eyebrowTextHtml }" field-name="eyebrowText" />
    </div>
    <cms-base-responsive-media
      v-if="eyebrowLogoResponsive"
      v-style="logoStyle"
      fit="contain"
      :media="eyebrowLogoResponsive"
      :position
      :props-img="propsImgLogo"
    />
    <base-picture
      v-else-if="eyebrowLogo"
      v-style="logoStyle"
      :alt="eyebrowLogo.alt"
      fit="contain"
      :position
      :props-img="propsImgLogo"
      :src="eyebrowLogo.url"
    />
  </div>
</template>

<script lang="ts" setup>
import type { Responsive } from '#types/common'
import type { StyledEyebrow } from '#types/styles'

type EyebrowProps = StyledEyebrow & {
  /**
   * Specifies responsive object-position values for the internal <img>
   */
  position?: Responsive | string
}

const { eyebrowLogoWidthResponsive = {} } = defineProps<EyebrowProps>()

const logoStyle = computed(() => {
  const normalized = normalizeResponsive(eyebrowLogoWidthResponsive)
  return Object.entries(normalized).reduce(
    (acc, [bp, val]) => ({
      w: { ...acc.w, [bp]: val ? `${val}%` : 'auto' },
      maxH: { ...acc.maxH, [bp]: val ? 'auto' : '6rem' },
    }),
    { w: {}, maxH: {} } as { w: Record<string, string>, maxH: Record<string, string> },
  )
})

const propsImgLogo = { class: 'object-left h-a w-full' }
</script>
